import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BackupApiService, BackupService } from '../../core/backup';
import { StagingApiService, StagingService } from '../../core/staging';
import { FilesizePipe } from '../../shared/pipes/filesize.pipe';
import { AppDialogModule } from '../dialog';
import { BackupDialogComponent } from './backup-dialog/backups.component';
import { BackupPageComponent } from './backup-page/backup-page.component';
import { BackupProUpgradeComponent } from './backup-pro-upgrade.component';
import { BackupTableComponent } from './backup-table/backup-table.component';
import { PluginInformationDialogComponent } from './plugins/plugins.component';
import { RestoreConfirmationDialogComponent } from './restore-dialog/restore.component';
import { GalaxyProgressBarComponent } from '@vendasta/galaxy/progress-bar';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';

import { LexiconModule } from '@galaxy/lexicon';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import baseTranslation from '../../../assets/i18n/en_devel.json';
import { WEBLATE_COMPONENT_NAME } from '../../constants';

const routes: Routes = [
  {
    path: '',
    component: BackupPageComponent,
  },
];

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    RouterModule.forChild(routes),
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    AppDialogModule,
    MatTabsModule,
    FormsModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    FilesizePipe,
    MatDialogModule,
    MatTooltipModule,
    MatChipsModule,
    GalaxyPageModule,
    GalaxyProgressBarComponent,
    GalaxyLoadingSpinnerModule
  ],
  declarations: [
    BackupPageComponent,
    BackupDialogComponent,
    PluginInformationDialogComponent,
    RestoreConfirmationDialogComponent,
    BackupTableComponent,
    BackupProUpgradeComponent,
  ],
  exports: [RouterModule],
  providers: [BackupService, BackupApiService, StagingService, StagingApiService],
})
export class BackupManagerModule {}
